module.exports = __webpack_public_path__ + "static/media/quiron@2x.503bc78b.jpg";